import Page from 'modules/Page';
import lazyWithSuspense from 'modules/lazyWithSuspense';
import { i18n } from 'i18n';
import makePage from 'modules/makePage';
import * as parentConstants from '../ProjectDetailsPage/constants';
import * as constants from './constants';
import useEditRheologyQueries, { EditRheologyQueries } from '../../shared/EditRheologyPage/useEditRheologyQueries';

const EditRheologyPage = lazyWithSuspense(() => import('./EditRheologyPage'));

type RouteParams = Readonly<Record<'entityId' | 'rheologyId', string | undefined>>;

function requireParams(p: RouteParams): { entityId: string; rheologyId: string } {
  if (!p.entityId || !p.rheologyId) {
    throw new Error('Missing route params: entityId and rheologyId are required');
  }
  return { entityId: p.entityId, rheologyId: p.rheologyId };
}

const page: Page = {
  title: constants.TITLE,
  routeProps: { path: constants.ROUTE_PATH },
  admin: true,
  component: makePage<RouteParams, EditRheologyQueries>({
    WrappedPage: EditRheologyPage,
    titleFn: ([rheologyQuery]) => {
      const title = rheologyQuery.data ? rheologyQuery.data.reference : '';
      return i18n._('Edit').concat(` ${title} Rheology Data`);
    },
    parentPathTemplate: parentConstants.ROUTE_PATH,
    parentTitleFn: () => i18n._(parentConstants.TITLE),
    pageDataHook: (p) => useEditRheologyQueries(requireParams(p)),
  }),
};

export default page;
